import React, { createContext, useMemo, useState } from 'react'

export type PageNavigatorContextValue = {
	register(comp: React.ReactNode): void
	unregister(): void
	getHeader(): React.ReactNode
}

export const PageNavigatorContext = createContext(
	{} as PageNavigatorContextValue
)
export const PageNavigatorConsumer = PageNavigatorContext.Consumer

export default function PageNavigatorProvider({
	children,
}: {
	children: React.ReactNode
}) {
	const [regiteredComponent, setRegiteredComponent] =
		useState<React.ReactNode | null>(null)
	const register = setRegiteredComponent

	const unregister = () => setRegiteredComponent(null)
	const getHeader = () => regiteredComponent
	const value = useMemo(
		(): PageNavigatorContextValue => ({
			register,
			unregister,
			getHeader,
		}),
		[regiteredComponent, register, unregister]
	)

	return <PageNavigatorContext value={value}>{children}</PageNavigatorContext>
}
